import { createSelector } from "reselect";
import { getSizotsaFuneralCover } from "./index";
import { getPurchasePersonalDetailsForm } from "./personalDetails";

export const getUploadDocuments = createSelector(
    getSizotsaFuneralCover,
    (sizotsaFuneralCover) => sizotsaFuneralCover.uploadDocuments
);
export const getUploadDocumentForm=createSelector(
    getUploadDocuments,
    (uploadDocuments) => uploadDocuments.form
)

const inputFieldLabels = {
    certifiedCopyOfId: 'Copy of  certified ID / passport for Non-Swazi',
    incomeProof:'Proof of income (letter from employer/latest payslip/bank statement) ' ,
    addressProof:'Proof of address (letter from employer/affidavit/latest utility bill)',
    bankStatement:'Confirmation of bank account (bank statement/bank confirmation letter)'  ,
};


export const getUploadDocumentsSummary = createSelector(
    getPurchasePersonalDetailsForm,
    getUploadDocumentForm,
    ({ employementType }, uploadDocumentForm) => {
        const { incomeProof, ...filteredDocument } = uploadDocumentForm;
        return Object.keys(employementType?.value === 'Employed' ? uploadDocumentForm : filteredDocument)
            ?.flatMap((item) => ({
                label: inputFieldLabels[item],
                value: uploadDocumentForm[item]?.fileName ?? '-',
            }))
            .filter(({ label }) => label);
    }
);

export const getDocumentsRequired=createSelector( getPurchasePersonalDetailsForm,(  purchasePersonalDetailsForm)=>{
    const {employementType}=purchasePersonalDetailsForm
    return employementType.value === 'Employed' ? ({
    certifiedId:'Copy of  certified ID / passport for Non-Swazi',
    addressProof:'Proof of address (letter from employer/affidavit/latest utility bill)',
    incomeProof:'Proof of income (letter from employer/latest payslip/bank statement) ' ,
    bankProof:'Confirmation of bank account (bank statement/bank confirmation letter)'  ,
}):({
    certidiedId:'Copy of  certified ID / passport for Non-Swazi',
    addressProof:'Proof of address (letter from employer/affidavit/latest utility bill)',
    bankProof:'Confirmation of bank account (bank statement/bank confirmation letter)'  ,
})
})

export const getDocumentsArray = createSelector(getUploadDocumentForm, (uploadDocuments) => {
    return uploadDocuments
});